import { render, staticRenderFns } from "./RaceCommandManager.vue?vue&type=template&id=2f0bd07a&scoped=true&"
import script from "./RaceCommandManager.vue?vue&type=script&lang=js&"
export * from "./RaceCommandManager.vue?vue&type=script&lang=js&"
import style0 from "./RaceCommandManager.vue?vue&type=style&index=0&id=2f0bd07a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0bd07a",
  null
  
)

export default component.exports